import { useEffect, useState } from 'react';
import { api, call } from '../platform/api.js';

/**
 * What the DATABASE thinks you are — the end-to-end proof of the auth chain: Supabase
 * token -> container verification -> auth_identity() -> tenant session -> RLS-filtered
 * read. If this renders a role, every one of those links is live.
 *
 * The role shown here is never used to decide what the UI permits. Capability checks
 * belong on the server, where the row lives; a client-side role is a display value.
 *
 * ⚠️ RENDERS THE TWO About label/value rows ONLY (frame 2j: "About as label/value rows").
 * Sign out moved UP to the Settings About section so the frame's order holds — Version, Signed
 * in, Tenant, the tagline, then Sign out — which this component cannot own because the tagline
 * sits between its rows and that button. It stays a component (not inlined) because the auth-chain
 * proof above is worth keeping named at one place.
 */
export function Identity(): JSX.Element {
  const [who, setWho] = useState<{ role: string; tenant: string } | null>(null);
  const [line, setLine] = useState('checking…');
  const [problem, setProblem] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const result = await call('whoami', () => api.whoami.query());
      if (cancelled) return;
      if (result.ok) {
        setWho({ role: result.data.role, tenant: result.data.tenantId.slice(0, 8) });
        setProblem(null);
      } else {
        setWho(null);
        setLine('unknown');
        setProblem(result.failure.message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <div className="settings-about-row">
        <span>Signed in</span>
        <strong>{who?.role ?? line}</strong>
      </div>
      {who !== null && (
        <div className="settings-about-row">
          <span>Tenant</span>
          <span className="settings-about-mono">{who.tenant}</span>
        </div>
      )}
      {problem !== null && (
        <p role="alert" className="settings-about-problem">
          {problem}
        </p>
      )}
    </>
  );
}
